import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { EditQuestion } from '../model/edit-question.model';
import { Story } from '../model/story.model';
import { CloudinaryService } from '../shared/services/cloudinary.service';
import { EditQuestionService } from './edit-question.service';
import { Quiz } from '../model/quiz.model';
import { QuestionAndAnswersDTO } from '../model/question-and-answers.model';
import { EditQuiz } from '../model/edit-quiz.model';
import { QuizV2 } from '../model/current-quiz.model';
import { HomeService } from '../home/home.service';
import { AnswerOption } from '../model/answer-option.model';
import { MatSelectChange } from '@angular/material/select';
import { Cloudinary } from '@cloudinary/angular-5.x';
import { FileUploader, FileUploaderOptions, ParsedResponseHeaders } from 'ng2-file-upload';

@Component({
  selector: 'app-edit-quiz',
  templateUrl: './edit-quiz.component.html',
  styleUrls: ['./edit-quiz.component.scss']
})
export class EditQuizComponent implements OnInit {
  quizzes: QuizV2[];
  // editQuizForm: FormGroup;
  editQuizModel = new EditQuiz;
  answerOptions: AnswerOption[] = [{answerText: 'Answer Option 1', answerValue: 1}, {answerText: 'Answer Option 2', answerValue: 2}, {answerText: 'Answer Option 3', answerValue: 3}, {answerText: 'Answer Option 4', answerValue: 4}];
  currentQuestionIndex: number = 0;
  currentQuestionAndAnswers: Array<QuestionAndAnswersDTO>[] = null;
  isFormReady: boolean = false;
  currentQuestionImageURL: string = null;
  enableNextQuestionButton: boolean = false;
  enablePreviousQuestionButton: boolean = false;
  selectedQuiz: QuizV2 = null; 
  responsiveVoiceCancelInterval: number = 0;
  isSelectedQuiz: boolean = false;
  showErrorSection: boolean = false;
  correctAnswerOptionValue: number = 0;
  isFormSubmitReady : boolean = true;
  cloudinaryInterval : number = 0;

  constructor(
    private fb: FormBuilder,
    private cloudinary: Cloudinary,
    public cloudinaryService: CloudinaryService,
    public editQuestionService: EditQuestionService,
    public toast: ToastrService,
    private router: Router,
    private http: HttpClient,
    private homeService: HomeService
  ) { }

  ngOnInit(): void {
    this.getAllQuizzes();
    this.homeService.disableResponsiveVoice();
    this.cloudinaryService.responses = [];
    this.cloudinaryService.uploadToCloudinary();
  }

  onSubmit(editQuizForm: FormGroup){
    this.editQuizModel = null;
    this.editQuestionService.saveQuestionChanges(this.selectedQuiz).subscribe((response) => {
      this.toast.success("Quiz Edited Successfully! Feel free to edit more...");
      this.reloadComponent();
    });
   }

   getQuizByStorySelection(quizId: string){
      if(quizId != "undefined"){
        this.currentQuestionIndex = 0;
        this.http.post(environment.BACKEND_HOST + environment.BACKEND_QUIZ_ENDPOINT + "/editQuiz", quizId)
        .subscribe((response: QuizV2) => {
          console.log(response);
          if(response.questionAndAnswersDTO.length > 0){
            this.selectedQuiz = response;
            
            this.setQuestionImage(this.selectedQuiz.questionAndAnswersDTO, this.currentQuestionIndex);
            this.enableNextQuestionButton = true;
            this.isSelectedQuiz = true;
            this.showErrorSection = false;
            this.resetQuestionButtons();
            this.setCorrectAnswerOptionValue(this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].correctAnswerChoice);
          }else{
            this.isSelectedQuiz = false;
            this.showErrorSection = true;
          }
        });
      }else{
        this.isSelectedQuiz = false;
        this.showErrorSection = true;
      }
      // this.setCorrectAnswerOptionValue();
    }

    setQuestionImage(currentQuestionAndAnswers: [QuestionAndAnswersDTO], index?: number){
      if(this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionDTO.questionImage){
        this.currentQuestionImageURL = this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionDTO.questionImage;
      }else if(this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionImagePath){
        this.currentQuestionImageURL = this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionImagePath;
      }
      // this.currentQuestionImageURL = this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionDTO.questionImage;
    }

    populateNextQuestion(){
      var quizQuestionLength : number = this.selectedQuiz.questionAndAnswersDTO.length;
      this.currentQuestionIndex++;
      this.setQuestionImage(this.selectedQuiz.questionAndAnswersDTO, this.currentQuestionIndex);
      this.setCorrectAnswerOptionValue();
      if((this.currentQuestionIndex + 1) >= this.selectedQuiz.questionAndAnswersDTO.length){
        this.enableNextQuestionButton = false;
        if(quizQuestionLength == 2){
          this.enablePreviousQuestionButton = true;
        }
      }else{
        this.enableNextQuestionButton = true;
        this.enablePreviousQuestionButton = true;
      }
    }

    setCorrectAnswerOptionValue(newCorrectAnswer?: string){
      if(newCorrectAnswer){
        this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].correctAnswerChoice = newCorrectAnswer;
        this.correctAnswerOptionValue = +newCorrectAnswer;
      }else{
        for(var i = 0 ; i < 4; i++){
          var currentAnswer = this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].answersDTO[i];
          var correctAnswerBoolean : boolean = currentAnswer.correctAnswer == "true";
          if(correctAnswerBoolean){
            this.correctAnswerOptionValue = (i+1);
            this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].correctAnswerChoice = this.correctAnswerOptionValue.toString();
            return ;
          }
        }
      }
    }

    populatePreviousQuestion(){
      this.currentQuestionIndex--;
      var quizQuestionLength : number = this.selectedQuiz.questionAndAnswersDTO.length;
      this.setQuestionImage(this.selectedQuiz.questionAndAnswersDTO, this.currentQuestionIndex);
      this.setCorrectAnswerOptionValue();
      if((this.currentQuestionIndex - 1) < 0){ 
        this.enablePreviousQuestionButton = false;
        if(quizQuestionLength == 2){
          this.enableNextQuestionButton = true;
        }
      }else{
        this.enableNextQuestionButton = true;
        this.enablePreviousQuestionButton = true;
      }
    }

    getAllQuizzes(){
      this.http.get(environment.BACKEND_HOST + environment.BACKEND_QUIZ_ENDPOINT)
      .subscribe((response: QuizV2[]) => {
        this.quizzes = response;
        var tempQuizzes = this.quizzes;
        this.quizzes = [new QuizV2(), ...tempQuizzes];

        this.isFormReady = true;
        this.selectedQuiz = response[0];
        console.log(this.selectedQuiz);
      });
    }

    updateAnswerOption($event: MatSelectChange){
      this.setCorrectAnswerOptionValue($event.value);
    }
    
    questionImageChanged(){  
      this.isFormSubmitReady = false;
      setInterval(() => {
        if(this.cloudinaryService.imageUploaded){
          var uploadedImgURL : string = this.cloudinaryService.fileUploadUrl;
          console.log(uploadedImgURL);
          this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].questionDTO.questionImage = uploadedImgURL;
          this.isFormSubmitReady = true;
          const interval_id = window.setInterval(function(){}, Number.MAX_SAFE_INTEGER);

          // Clear any timeout/interval up to that id
          for (let i = 1; i < interval_id; i++) {
            window.clearInterval(i);
          }
        }else{
          console.log("Cloudinary image uploading");
        }
      }, 7000);
    }

    resetQuestionButtons(){
      this.enableNextQuestionButton = true;
      this.enablePreviousQuestionButton = false;
      if(this.selectedQuiz.questionAndAnswersDTO.length == 1){
        this.enableNextQuestionButton = false;
        this.enablePreviousQuestionButton = false;
      }
    }

   reloadComponent() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate(['/editQuiz']);
  }

  defaultCorrectAnswerOption(){
    this.selectedQuiz.questionAndAnswersDTO[this.currentQuestionIndex].correctAnswerChoice
  }


}
